<template>
	<div id="sidebar">
		<odometer-wrapper/>
        <filter-wrapper/>
	</div>
</template>

<script>
    import OdometerWrapper from './OdometerWrapper.vue';
    import FilterWrapper from '../components/FilterWrapper.vue';

    export default {
        components: {
            'odometer-wrapper': OdometerWrapper,
            'filter-wrapper': FilterWrapper
        }
    }
</script>

<style>
    #sidebar {
        width: calc(10 * var(--vw));
        background-color: #2B2A2B;
        height: inherit;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

</style>
